export default {
  pageTitle: 'Fabrikasi Piping',
  metaDescription: 'TEF memfabrikasi spool piping prefabrikasi berbahan titanium, duplex, dan alloy untuk instalasi efisien di pabrik petrokimia dan farmasi.',
  sidebar: {
    title: 'Daftar Fabrikasi',
    vessel: 'Fabrikasi Vessel',
    heatExchanger: 'Fabrikasi Heat Exchanger',
    piping: 'Fabrikasi Piping',
    tower: 'Fabrikasi Tower',
    muffle: 'Fabrikasi Muffle',
    radiantTube: 'Fabrikasi Radiant Tube',
    otherEquipment: 'Fabrikasi Other Equipment',
  },
  fabricationOf: 'Fabrikasi',
  product: {
    name: 'Piping',
    desc: 'Berikut adalah katalog pengalaman kami dalam fabrikasi Piping dengan berbagai jenis material, tipe, dan spesifikasi.',
  },
};
